import "./NewsAppPushMessagesListTable.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsAppPushMessagesListTable",
  props: {
    showFilter: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    itemsPerPage: 10,
    page: 1,
    items: [],
    headers: [
      {
        text: "Titel",
        align: "start",
        value: "title"
      },
      {
        text: "Nachricht",
        align: "start",
        value: "message"
      },
      {
        text: "Ausführungszeitpunkt",
        align: "start",
        value: "executionDate"
      },
      {
        text: "Für Nachricht",
        align: "start",
        value: "news_title"
      },
      { text: "Erstellt von", value: "owner_id" },
      { text: "Erstellt am", value: "create_date" }
    ],
    hideSentAppPushMessagesInList: false,
    pageCount: 0
  }),
  async mounted() {
    await this.fetchData();
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    allUsers() {
      return this.$store.state.users;
    },
    cItems() {
      if (this.hideSentAppPushMessagesInList) {
        return this.items.filter(
          appPushMessage => appPushMessage.isPending === true
        );
      }
      return this.items;
    },
    visibleItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.cItems.slice(start, end);
    }
  },
  watch: {
    page() {
      this.fetchNewsForVisibleItems();
    },
    hideSentAppPushMessagesInList() {
      this.fetchNewsForVisibleItems();
    }
  },
  methods: {
    nextPage() {
      const pages = Math.ceil(this.cItems.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    async fetchData() {
      await this.$store.dispatch("getAllUsers");
      await this.getAppPushMessages();
      await this.fetchNewsForVisibleItems();
    },
    async fetchNewsForVisibleItems() {
      const itemsToFetch = this.visibleItems.filter(
        item => item.news_title === undefined && item.news_deleted === undefined
      );
      for (const item of itemsToFetch) {
        const news = await this.getNewsById(item);
        if (news) {
          this.$set(item, "news_title", news.title);
          this.$set(item, "news_deleted", news.deleted);
        }
      }
    },
    async getAppPushMessages() {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const res = await axios.get(
          env.news_api_client_url + "app_push_message",
          {
            headers,
            params
          }
        );
        this.items = res.data;
      } catch (e) {
        await this.createError(e);
      }
    },
    async getNewsById(item) {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const response = await axios.get(
          `${env.news_api_client_url}news/${item.news_id}`,
          {
            headers,
            params
          }
        );
        return response.data;
      } catch (e) {
        await this.createError(e);
      }
    },
    isNewsForAppPushMessageDeleted(appPushMessage) {
      const classes = [];
      if (appPushMessage.news_deleted) {
        classes.push("news_deleted");
        if (appPushMessage.isPending === true) {
          classes.push("pending");
        }
      }
      return classes.join(" ");
    },
    async createError(error) {
      await this.$store.dispatch("createError", error);
    },
    getUserName(id) {
      const user = this.allUsers.find(user => user._id.toString() === id);
      if (!user) {
        return "---";
      }
      return `${user.first_name} ${user.last_name}`;
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    }
  }
};
